import { render, staticRenderFns } from "./oldCustomerList.vue?vue&type=template&id=30a96606&scoped=true&"
import script from "./oldCustomerList.vue?vue&type=script&lang=js&"
export * from "./oldCustomerList.vue?vue&type=script&lang=js&"
import style0 from "./oldCustomerList.vue?vue&type=style&index=0&id=30a96606&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30a96606",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCard,VIcon})
